import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg24CoverG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
      children: [/*#__PURE__*/jsxs("g", {
        strokeWidth: 1.333,
        children: [/*#__PURE__*/jsx("path", {
          d: "M19.356 19.008H9.632v-3.565a1.27 1.27 0 0 0-1.27-1.271h-.007l-4.253.02V3.754c0-.702.57-1.271 1.271-1.271h10.261l2.462 2.372.003.003 2.528 2.449v10.429c0 .702-.57 1.271-1.271 1.271z"
        }), /*#__PURE__*/jsx("path", {
          fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
          d: "M5.373 2.992h9.724v3.565a1.27 1.27 0 0 0 1.27 1.271h.007l4.253-.02v11.99c0 .702-.57 1.271-1.271 1.271H5.373a1.27 1.27 0 0 1-1.27-1.27V4.262a1.27 1.27 0 0 1 1.27-1.271z"
        })]
      }), /*#__PURE__*/jsx("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.467,
        d: "M12.267 8.8v.733m0 2.2v4.4"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24CoverG$1 = Svg24CoverG;

export { Svg24CoverG$1 as default };
